import axios, { AxiosPromise } from 'axios'

interface ImprimirInativoInput {
  coUnicoAtendProf: string
}

interface ImprimirAuditoriaInput {
  coUnicoAtendProf: string
}

const RETIFICACAO_API_URL = '/api/retificacaoAtendimento'

export class RetificacaoAtendimento {
  imprimirRegistrosInativos(coUnicoAtendProf: string): AxiosPromise<Blob> {
    const imprimirInativoInput: ImprimirInativoInput = { coUnicoAtendProf }
    return axios.post(`${RETIFICACAO_API_URL}/imprimirRegistrosInativos`, imprimirInativoInput, {
      responseType: 'blob',
    })
  }

  imprimirAuditoria(coUnicoAtendProf: string): AxiosPromise<Blob> {
    const imprimirAuditoriaInput: ImprimirAuditoriaInput = { coUnicoAtendProf }
    return axios.post(`${RETIFICACAO_API_URL}/imprimirAuditoria`, imprimirAuditoriaInput, {
      responseType: 'blob',
    })
  }
}
